import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid2 as Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faUsers, faHandHoldingUsd, faDotCircle, faKaaba, faCubes, faTabletAlt, faAngleDoubleRight, faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";


const IntroContent01 = ({expanded, handleChange}) => {
    const { t } = useTranslation();
    const iconType = <FontAwesomeIcon icon={faSquarePlus} size="lg" style={{ fontSize: "40px", paddingRight: '10px', paddingLeft: '10px' }} />;

    return (
        <Container className="info-container" slotProps={{ transition: { unmountOnExit: true } }}>
            <Accordion key='panel_info_1_1' id='panel_info_1_1' sx={{ width: '100%', padding: "0px 0px 0px 0px", margin: "0px 0px 0px 0px" }} expanded={expanded === 'panel_info_1_1'}  onChange={handleChange('panel_info_1_1')}>
                <AccordionSummary className="info-header" expandIcon={iconType} sx={{ p: 0, m: 0 }} aria-controls="panel-info-1-1-content" id="panel-info-1-1-header">
                    <Container sx={{ p: 0, m: 0 }}>
                        <Box>
                            <Box component='div' className="info-header-section1" sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' } }} />
                            <h1 className="info-header-title">
                                {t('bwob.task1.section1.title')} ｜ {t('bwob.task1.section1.item')}
                            </h1>
                            <p className="info-header-descript">
                                “{t('bwob.task1.section1.description')}”
                            </p>
                        </Box>
                    </Container>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, m: 0 }}>
                    <Container className="info-content">
                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.subject1')}</strong><br />
                        </div>

                        <Grid container alignItems="center" spacing={1} className="info-stats" sx={{ padding: "0px 20px" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, }} sx={{ padding: "10px 20px" }}>
                                <div  className="info-statbox coffee-busan-background00">
                                    <Box component='div' className="info-stat-10" sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } }} />
                                    <h3><FontAwesomeIcon icon={faUsers} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.w004')}</h3>
                                    <p>{t('bwob.words.w001')} 6.8%(13,509{t('bwob.words.w005')})<br />9.0%(51,691{t('bwob.words.w006')}) <br />{t('bwob.words.w003')}({t('bwob.words.w004')})</p>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, }} sx={{ padding: "10px 20px" }}>
                                <div  className="info-statbox coffee-busan-background00">
                                    <Box component='div' className="info-stat-20" sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } }} />
                                    <h3><FontAwesomeIcon icon={faHandHoldingUsd} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.w005')}</h3>
                                    <p>{t('bwob.words.w002')} 9.1% (7,427{t('bwob.words.w007')})<br />{t('bwob.words.w027')} 11.9%(3,713{t('bwob.words.w007')}) <br />{t('bwob.words.w003')}({t('bwob.words.w004')})</p>
                                </div>
                            </Grid>
                        </Grid>

                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.subject2')}</strong><br />
                            <Grid container alignItems="center" spacing={1} sx={{ padding: '10px 30px'}}>
                                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }} sx={{ borderRight: { xs: 'none', sm: '1px solid #d0d0d0' } }}>
                                    <span className="infrastructure_logo01">{t('bwob.task1.section1.subject2-sub01')}</span>        
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }} sx={{ borderRight: { md: 'none', lg: '1px solid #d0d0d0' } }}>
                                    <span className="infrastructure_logo02">{t('bwob.task1.section1.subject2-sub02')}</span>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }} sx={{ borderRight: { xs: 'none', sm: '1px solid #d0d0d0' } }}>
                                    <span className="infrastructure_logo03">{t('bwob.task1.section1.subject2-sub03')}</span>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }} sx={{ }}>
                                    <span className="infrastructure_logo04">{t('bwob.task1.section1.subject2-sub04')}</span>
                                </Grid>
                            </Grid>
                        </div>

                        <Grid container alignItems="center" spacing={1} columns={7} className="info-stats" sx={{ padding: "0px 20px" }}>
                            <Grid item size={{ xs: 3.5, sm: 2.3, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <Box component='div' className="info-item-been" />
                                        {t('bwob.words.w008')} 
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingLeft: '10px' }}/>
                                    </div>
                                    {t('bwob.words.w015')}<br />{t('bwob.words.w016')}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 3.5, sm: 2.3, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingRight: '10px' }}/>
                                        {t('bwob.words.w009')} 
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingLeft: '10px' }}/>
                                    </div>
                                    {t('bwob.words.w017')}<br />{t('bwob.words.w018')}
                                    <br /><FontAwesomeIcon icon={faArrowCircleDown} size="lg" />
                                    <br /><strong><FontAwesomeIcon icon={faCubes} style={{ paddingRight: '5px' }}/>{t('bwob.words.w014')}</strong>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 3.5, sm: 2.3, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingRight: '10px' }}/>
                                        {t('bwob.words.w010')} 
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingLeft: '10px' }}/>
                                    </div>
                                    {t('bwob.words.w019')}<br />{t('bwob.words.w020')}<br />{t('bwob.words.w021')}<br />{t('bwob.words.w022')}
                                    <br /><FontAwesomeIcon icon={faArrowCircleDown} size="lg" />
                                    <br /><strong><FontAwesomeIcon icon={faCubes} style={{ paddingRight: '5px' }}/>{t('bwob.words.w014')}</strong>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 3.5, sm: 2.3, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingRight: '10px' }}/>
                                        {t('bwob.words.w011')} 
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingLeft: '10px' }}/>
                                    </div>
                                    {t('bwob.words.w023')}<br />{t('bwob.words.w011')}
                                    <br /><FontAwesomeIcon icon={faArrowCircleDown} size="lg" />
                                    <br /><FontAwesomeIcon icon={faCubes} style={{ paddingRight: '5px' }}/><strong>{t('bwob.words.w014')}</strong>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 3.5, sm: 2.3, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingRight: '10px' }}/>
                                        {t('bwob.words.w010')} 
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingLeft: '10px' }}/>
                                    </div>
                                    {t('bwob.words.w019')}<br />{t('bwob.words.w020')}<br />{t('bwob.words.w021')}<br />{t('bwob.words.w022')}
                                    <br /><FontAwesomeIcon icon={faArrowCircleDown} size="lg" />
                                    <br /><FontAwesomeIcon icon={faCubes} style={{ paddingRight: '5px' }}/><strong>{t('bwob.words.w014')}</strong>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 3.5, sm: 2.3, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingRight: '10px' }}/>
                                        {t('bwob.words.w012')} 
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingLeft: '10px' }}/>
                                    </div>
                                    {t('bwob.words.w023')}<br />{t('bwob.words.w012')}
                                    <br /><FontAwesomeIcon icon={faArrowCircleDown} size="lg" />
                                    <br /><FontAwesomeIcon icon={faCubes} style={{ paddingRight: '5px' }}/><strong>{t('bwob.words.w014')}</strong>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 7, sm: 7, md: 1, }} sx={{ padding: "0px" }}>
                                <div className="info-item-box">
                                    <div className="info-timeline-box">
                                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ paddingRight: '10px' }}/>
                                        {t('bwob.words.w013')}
                                    </div>
                                    <FontAwesomeIcon icon={faCubes} style={{ paddingRight: '5px' }}/><strong>{t('bwob.words.w014')}</strong>
                                    <br /><FontAwesomeIcon icon={faArrowCircleDown} size="lg" />
                                    <br /><strong><FontAwesomeIcon icon={faTabletAlt} style={{ paddingRight: '5px' }}/>{t('bwob.words.w024')}</strong>
                                    <br />{t('bwob.words.w025')}<br />{t('bwob.words.w026')}
                                </div>
                            </Grid>
                        </Grid>

                        <div className="info-highlight info-footer">
                            <Grid container alignItems="center" spacing={1} sx={{ padding: '0', margin: '0', width: '100%' }}>
                                <Grid item size={{ xs: 12, sm: 12, md: 4, }} sx={{ textAlign: 'center', alignItems: 'center', borderRight: { sm: 'none', md: '1px solid #d0d0d0' } }}>
                                    <FontAwesomeIcon icon={faDotCircle} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.w001')}<br />(’16~’25)
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 4, }} sx={{ textAlign: 'center', alignItems: 'center', borderRight: { sm: 'none', md: '1px solid #d0d0d0' } }}>
                                    <FontAwesomeIcon icon={faDotCircle} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.w002')}<br />(’19)
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 4, }} sx={{ textAlign: 'center', alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faDotCircle} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section1.w003')}<br />(’17~’26)
                                </Grid>
                            </Grid>
                        </div>

                    </Container>
                </AccordionDetails>
            </Accordion>

        </Container>
    );
};

IntroContent01.propTypes = {
    expanded: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default IntroContent01;